import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/Retail/theme/components/quickview/index.js